import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAwesomewmComponent } from './simple-icons-awesomewm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAwesomewmComponent ],
    exports:      [ SimpleIconsAwesomewmComponent ],
    bootstrap:    []
})
export class SimpleIconsAwesomewmModule {}
